import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-stores',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map